
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_11270_31119)","stroke":"green","stroke-width":"1.5","stroke-linecap":"round"}},[_c('path',{attrs:{"d":"M3.334 9.167H1.667c.42-4.211 3.981-7.5 8.313-7.5 4.614 0 8.354 3.73 8.354 8.333 0 4.602-3.74 8.333-8.354 8.333a8.357 8.357 0 01-7.659-5","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.126 9.152V7.659c0-1.008.84-1.826 1.875-1.826 1.036 0 1.875.818 1.875 1.826v1.493m-1.875 5.015c1.611 0 2.917-1.272 2.917-2.84 0-1.568-1.306-2.84-2.917-2.84-1.61 0-2.916 1.272-2.916 2.84 0 1.568 1.305 2.84 2.916 2.84z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_11270_31119"}},[_c('path',{attrs:{"fill":"#fff","transform":"matrix(-1 0 0 1 20 0)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    